/**
 * Platform L3 Taška★ offer@SP bag DTOs (Wave 5 / NEW G8).
 * Parallel to sales-point-contacts — never merge with SP ★ types.
 */

export interface CustomerOfferFavoriteListItemDTO {
  id: number;
  title: string;
  name: string;
  imageUrl: string | null;
  thumbnailUrl: string | null;
  price: number | null;
  listable: boolean;
  salesPointContext: {
    salesPointId: number;
    code: string;
    name: string;
  };
  productContext: {
    productId: number;
    variantId: number | null;
  };
  tenantContext: {
    tenantId: number;
    tenantCode: string;
    tenantName: string;
  };
  createdAt: string;
}

export interface ListCustomerOfferFavoritesResultDTO {
  items: CustomerOfferFavoriteListItemDTO[];
}

/** Guest LS / claim body ref for one offer@SP grain. */
export interface ClaimCustomerOfferFavoriteRef {
  tenantCode: string;
  salesPointId?: number;
  salesPointSlug?: string;
  productId: number;
  variantId?: number | null;
  seenAt: string;
}

export interface ClaimCustomerOfferFavoritesBody {
  favorites: ClaimCustomerOfferFavoriteRef[];
}

export interface ClaimCustomerOfferFavoritesResultDTO {
  activated: {
    tenantCode: string;
    salesPointId: number;
    productId: number;
    variantId: number | null;
  }[];
  failed: { ref: ClaimCustomerOfferFavoriteRef; code: string }[];
}

export interface SetCustomerOfferFavoriteResultDTO {
  salesPointId: number;
  productId: number;
  variantId: number | null;
  favorited: boolean;
}

export interface RemoveCustomerOfferFavoriteResultDTO {
  removed: boolean;
  salesPointId: number;
  productId: number;
  variantId: number | null;
}

/** LOCKED claim/setFavorite failure codes (Wave 5 / NEW G8 / D20c). */
export const OFFER_FAVORITE_ERROR_CODES = {
  MEMBERSHIP_BLOCKED: 'MEMBERSHIP_BLOCKED',
  SP_NOT_FOUND: 'SP_NOT_FOUND',
  SP_NOT_PRODUCTS: 'SP_NOT_PRODUCTS',
  SP_INACTIVE: 'SP_INACTIVE',
  OFFER_NOT_FOUND: 'OFFER_NOT_FOUND',
  OFFER_NOT_LISTABLE: 'OFFER_NOT_LISTABLE',
  CLAIM_CAP_EXCEEDED: 'CLAIM_CAP_EXCEEDED',
} as const;

export type OfferFavoriteGrainKey = {
  readonly salesPointId: number;
  readonly productId: number;
  readonly variantId: number | null;
};

export function offerFavoriteGrainKey(grain: OfferFavoriteGrainKey): string {
  const variant =
    grain.variantId === null || grain.variantId === undefined
      ? 'null'
      : String(grain.variantId);
  return `${grain.salesPointId}|${grain.productId}|${variant}`;
}
